import { GET_STUDENT_JOBS } from '../../actions';
import { FAILURE, INVALIDATE, REQUEST, SUCCESS } from '../../actions/utils';
import { ICommonResponseObject, IJobsResponse } from '../../api/types';
import { connectReducers } from '../../utils';
import { IReducers } from '..';
import genericReducers from '../genericReducer';

export type StudentJobsState = ICommonResponseObject<IJobsResponse>;

const initialState: StudentJobsState = {
  content: {
    job: [],
  },
  loading: false,
};
const generic = genericReducers<StudentJobsState>();
const studentJobs: IReducers<StudentJobsState> = {
  [GET_STUDENT_JOBS[REQUEST]]: generic.get.request,
  [GET_STUDENT_JOBS[SUCCESS]]: generic.get.success,
  [GET_STUDENT_JOBS[FAILURE]]: generic.get.failure,
  [GET_STUDENT_JOBS[INVALIDATE]]: generic.get.invalidate(initialState),
};

export default connectReducers(initialState, studentJobs);
